var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination",attrs:{"role":"group","aria-label":"分页"}},[_c('el-pagination',{attrs:{"page-sizes":[5, 10, 50, 100,500],"page-size":_vm.size,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }